import React from 'react'
import image1 from '../public/images/cat1.jpg'
import image2 from '../public/images/cat2.jpg'
import image3 from '../public/images/cat3.jpg'
import image4 from '../public/images/cat4.jpg'
import image5 from '../public/images/cat5.jpg'
import image6 from '../public/images/cat6.jpg'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const Category = () => {
  const cats=[image1,image2,image3,image4,image5,image6];
  const {categories}=useSelector((state)=>state.HomeReducer);
  return (
        <div className='container category-container mx-auto  m-0 g-4'>
    {categories.map((category,idx)=>(
      <Link to={`/main_category/${category.id}/${category.name}`}  className='category col-sm-6  col-md-4  col-xlg-2'  key={idx}>
        <img  src={category.image} />
        {/* <div className="">
          {category.name}
      </div> */}
    </Link>
    ))}
    </div>

  )
}

export default Category
